import { apiConfigs } from "@apis/axiosInstance";

import axiosBaseQuery from "../axiosBaseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
    getFeedbackInputPayload,
    getFeedbackOutputPayload,
    InputFeedbackPayload,
    OutputFeedbackPayload,
} from "@convin/type/Feedback";

const protocol = import.meta.env.VITE_APP_API_PROTOCOL ?? apiConfigs.HTTPS;
const api = import.meta.env.VITE_APP_GENESIS_SERVICE_URL;
const baseApi = api ? `${protocol}${api}/` : "https://genesis.convin.ai/v1";

export const feedbackSlice = createApi({
    reducerPath: "thumbsUpDownSlice",
    baseQuery: axiosBaseQuery({
        baseUrl: `${baseApi}`,
    }),
    endpoints: (builder) => {
        return {
            giveFeedback: builder.mutation<
                OutputFeedbackPayload,
                InputFeedbackPayload
            >({
                query: (feedback) => ({
                    url: "/feedback",
                    method: "POST",
                    body: feedback,
                }),
            }),

            getFeedback: builder.mutation<
                getFeedbackOutputPayload,
                getFeedbackInputPayload
            >({
                query: (feedback) => ({
                    url: "/get_feedback",
                    method: "POST",
                    body: feedback,
                }),
            }),
        };
    },
});

export const { useGiveFeedbackMutation, useGetFeedbackMutation } =
    feedbackSlice;
